module.exports = __webpack_public_path__ + "static/media/Zach McDonald.65d1f6bb.png";